module.exports = __webpack_public_path__ + "static/media/logo-dats-why.bd5b0713.svg";